/* eslint-disable tailwindcss/no-custom-classname */
import React, { FC } from 'react';

import EllipsisTooltipText from '@components/ellipsis-tooltip-text/EllipsisTooltipText';

import { PairPanelCardPropType } from './types';

const PairPanelCard: FC<PairPanelCardPropType> = ({
  panelData,
  header,
  customStyle,
  childrenStyles
}) => {
  return (
    <>
      <div className="text-xl font-semibold leading-8">{header}</div>
      <div className={`flex rounded-lg  max-w-fit  border-r-0 ${customStyle}`}>
        {panelData.map((item, index) => (
          <div
            key={item.label}
            className={`${index === 0 && '!pl-5'} ${childrenStyles} ${
              index === panelData.length - 1 ? '!pr-5' : 'border-r-0'
            } first-of-type:rounded-l-lg flex gap-5 justify-between py-5 border border-lightGrey bg-snowDrift px-[30px] min-w-[220px] text-sm leading-5 last-of-type:rounded-r-lg border-r border-collapse `}>
            <div className="text-sm font-normal text-gray-400">
              {item.label}
            </div>
            <div className="overflow-hidden min-w-[60px] max-w-[150px] text-sm font-medium truncate">
              <EllipsisTooltipText text={item.value} />
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default PairPanelCard;
